'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$115(ps$77) {
  this.a6J = null;
  this.a6J = ps$77;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$115 as $c_Lmealorama_jsonCodecs$package$$anon$115 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$115.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$115;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$115() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$115 as $h_Lmealorama_jsonCodecs$package$$anon$115 };
$h_Lmealorama_jsonCodecs$package$$anon$115.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6J.a.length;
});
$p.g = (function(i) {
  return this.a6J.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$115 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$115, "mealorama.jsonCodecs$package$$anon$115", ({
  Ip: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$115 as $d_Lmealorama_jsonCodecs$package$$anon$115 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$115.js.map
